/**
 * Abstract sound IDs for TTS codewords `[[sound:…]]` / `[[soundasync:…]]`.
 * Set each value to your hosted URL (or leave `''` and rely on `__LECTURA_TTS_SOUNDS_BASE__` + `.mp3` by key name).
 *
 * In notes you can use the key with hyphens or underscores, e.g. `music-motivational` ↔ `music_motivational`.
 */

export const TTS_SOUND_CATALOG = {
  applause: 'https://ken-vernaillen.github.io/lectura-sounds/applause.mp3',
  joke: 'https://ken-vernaillen.github.io/lectura-sounds/joke.mp3',
  success_ding: 'https://ken-vernaillen.github.io/lectura-sounds/success.mp3',
  fail_buzz: 'https://ken-vernaillen.github.io/lectura-sounds/fail.mp3',
  gasp: 'https://ken-vernaillen.github.io/lectura-sounds/gasp.mp3',
  drumroll: 'https://ken-vernaillen.github.io/lectura-sounds/drumroll.mp3',
  riser: 'https://ken-vernaillen.github.io/lectura-sounds/riser.mp3',
  pop: 'https://ken-vernaillen.github.io/lectura-sounds/pop.mp3',
  click: 'https://ken-vernaillen.github.io/lectura-sounds/click.mp3',
  camera_snap: 'https://ken-vernaillen.github.io/lectura-sounds/camera.mp3',
  notification_ping: 'https://ken-vernaillen.github.io/lectura-sounds/notification.mp3',
  music_epic_gladiators: 'https://ken-vernaillen.github.io/lectura-sounds/gladiator.mp3',
  music_epic_fantasy: 'https://ken-vernaillen.github.io/lectura-sounds/fantasy.mp3',
  music_epic_fight: 'https://ken-vernaillen.github.io/lectura-sounds/fight.mp3',
  music_christmas: 'https://ken-vernaillen.github.io/lectura-sounds/christmas.mp3',
  music_motivational: 'https://ken-vernaillen.github.io/lectura-sounds/motivational.mp3',
  music_suspense: 'https://ken-vernaillen.github.io/lectura-sounds/suspence.mp3',
  music_suspicious: 'https://ken-vernaillen.github.io/lectura-sounds/suspicious.mp3',
  music_ambient: 'https://ken-vernaillen.github.io/lectura-sounds/ambient.mp3',
  music_playful: 'https://ken-vernaillen.github.io/lectura-sounds/playful.mp3'
} as const;

export type TtsSoundId = keyof typeof TTS_SOUND_CATALOG;

/** Normalize user-facing key to catalog id (lowercase, hyphens → underscores). */
export function normalizeTtsSoundKey(key: string): string {
  return String(key || '')
    .trim()
    .toLowerCase()
    .replace(/-/g, '_');
}

/** Non-empty URL from catalog, or null if entry missing / still empty. */
export function getCatalogUrlForSoundKey(normalizedKey: string): string | null {
  if (!(normalizedKey in TTS_SOUND_CATALOG)) return null;
  const u = TTS_SOUND_CATALOG[normalizedKey as TtsSoundId];
  const t = typeof u === 'string' ? u.trim() : '';
  return t !== '' ? t : null;
}

export function isKnownTtsSoundKey(normalizedKey: string): boolean {
  return normalizedKey in TTS_SOUND_CATALOG;
}
